<template>
  <div class="view-more-layout" >
    <portal-target name="filter-overlay-list" class="overlay-portal" />
    <div class="view-more-contents" ref="contentsOverlay">
      <div class="common-header">
        <view-more-header :title-list="titleList" :close-fn="closeList" v-if="subType === 'general_list'"></view-more-header>
        <view-more-editor-pick-header :title-list="titleList" :close-fn="closeList" v-if="subType === 'editor_pick_list'" :top-button-list="topButtonList"></view-more-editor-pick-header>
        <div class="filter-area" v-if="hasFilter">
          <div class="filter-item-area">
              <filter-list-for-device
                v-for="(filterItem, index) in filterObject.filterlist"
                :key="'filter_' + index"
                :filter-item="filterItem"
                :contents-overlay-ref="$refs.contentsOverlay"
                :filter-title="filterTitleMap[index] || filterItem.filter_item_list[0].title"
                :filter-index="index"
                v-on:set-filter-query="setFilterQuery" >
              </filter-list-for-device>
          </div>
        </div>
      </div>
      <div :class="'view-more-component-container' + (hasFilter ? ' has-filter' : '') + (hasOneFilter ? ' has-one-filter' : '')" data-scroll-element="true" v-if="subType === 'general_list'">
        <portal-target name="filter-overlay" class="overlay-portal" />
        <infinite-scroll-cell-list v-if="cellList && cellList.length"
                                   key="infinite-scroll-cell-list"
                                   :cell-list="cellList"
                                   :thumbnail-info="thumbnailInfo"
                                   :container-class-name="getCellListContainerClassName"
                                   v-on:load-more="loadMore"
        />
        <div v-if="showEmptyList" class="empty-cell-list">
          <div class="attention-mark-area">
            <empty-image></empty-image>
          </div>
          <div class="text-area">
            해당데이터가 없습니다.
          </div>
        </div>
      </div>
      <div class="view-more-editor-component-container" data-scroll-element="true" v-if="subType === 'editor_pick_list'">
        <portal-target name="filter-overlay" class="overlay-portal" />
        <infinite-scroll-cell-list v-if="cellList && cellList.length"
                                   key="infinite-scroll-cell-list"
                                   :cell-list="cellList"
                                   :thumbnail-info="thumbnailInfo"
                                   :container-class-name="getCellListContainerClassName"
                                   v-on:load-more="loadMore"
        />
        <div v-if="showEmptyList" class="empty-cell-list">
          <div class="attention-mark-area">
            <empty-image></empty-image>
          </div>
          <div class="text-area">
            해당데이터가 없습니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EventService } from '@/common/api/api.service'
import { get, merge } from 'lodash'
import { parse, parseUrl, stringify } from 'query-string'
import ViewMoreHeader from '@/components/header/template/ViewMoreHeader'
import ViewMoreEditorPickHeader from '@/components/header/template/ViewMoreEditorPickHeader'
import EventModelClass from '@/common/model/EventModelClass'
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import FilterListForDevice from '@/components/section/template/FilterListForDevice'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import VueSticky from 'vue-sticky'
import EmptyImage from '@/assets/svg/common/img_empty.svg'
import { mapMutations, mapGetters } from 'vuex'
import { isMobileDevice } from '@/common/util/ua'
import { isApp } from '@/common/util/common'
export default {
  name: 'List',
  data () {
    // 여기서 필터 값까지 가지고 있다가 쿼리날리고 여기서 열때 선택된것 셋팅해줘야됨
    return {
      showEmptyList: false,
      currentEvent: {},
      hasFilter: false,
      titleList: [],
      thumbnailInfo: {},
      offset: 0,
      limit: 21,
      subType: '', // general_list, editor_pick_list
      genTime: '',
      selectedCategoryTitle: '',
      cellList: [],
      filterObject: {},
      filterQueryMap: undefined,
      filterTitleMap: {},
      endOfList: false,
      isLoading: false,
      topButtonList: []
    }
  },
  directives: {
    VueSticky
  },
  components: {
    FilterListForDevice,
    ViewMoreHeader,
    ViewMoreEditorPickHeader,
    InfiniteScrollCellList,
    EmptyImage
  },
  methods: {
    ...mapMutations(['hideListView']),
    setFilterQuery ({ queryString, selectedTitle, filterIndex }) {
      this.cellList = []
      this.offset = 0
      this.endOfList = false
      this.filterTitleMap[filterIndex] = selectedTitle
      this.filterQueryMap = merge(this.filterQueryMap, parse(queryString))
      const eventInstance = new EventModelClass(this.currentEvent)
      eventInstance.filter = this.filterQueryMap

      this.setData(eventInstance)
    },
    loadMore () {
      if (this.endOfList) return
      const eventInstance = new EventModelClass(this.currentEvent)
      eventInstance.filter = this.filterQueryMap
      eventInstance.offset = this.offset
      eventInstance.limit = this.limit
      eventInstance.setPaging(true)
      this.setData(eventInstance)
    },
    setData (eventInstance) {
      if (this.isLoading) return
      this.isLoading = true
      const { query } = parseUrl(eventInstance.url)
      EventService.requestEventData(eventInstance).then(({ data }) => {
        if (this.offset === 0) { // INFO : 처음에만
          this.filterObject = get(data, 'filter', {})
          this.subType = get(data, 'sub_type', '')
          this.titleList = get(data, ['cell_toplist', 'title_list'], [])
          this.topButtonList = get(data, ['cell_toplist', 'topbuttonlist'], [])
          this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
          if (get(this.filterObject, 'filterlist', []).length > 0) {
            this.hasFilter = true
          }
        }
        if (Object.keys(this.filterTitleMap).length === 0) {
          const filterList = get(this.filterObject, 'filterlist', [])
          filterList.forEach((filterItem, index) => {
            const filterItemList = get(filterItem, ['filter_item_list'], [])
            filterItemList.forEach((item, itemIndex) => {
              const params = parse(item.api_parameters)
              const key = Object.keys(params)[0]
              if (query[key] === params[key]) {
                this.filterQueryMap = Object.assign({}, this.filterQueryMap, params)
                this.filterTitleMap[index] = get(filterItemList, [String(itemIndex), 'title'], '')
              }
            })
            if (this.selectedCategoryTitle !== '') {
              filterItemList.forEach((filterItem) => {
                const filterTitle = get(filterItem, 'title', '')
                if (filterTitle === this.selectedCategoryTitle) {
                  this.filterTitleMap[index] = filterTitle
                }
              })
            }
          })
        }
        let resCellList = get(data, ['cell_toplist', 'celllist'], [])
        this.showEmptyList = this.cellList.length === 0 && resCellList.length === 0
        if (resCellList.length === 0) { this.endOfList = true }
        this.offset += this.limit
        this.cellList = this.cellList.concat(resCellList)
        this.isLoading = false
      }).catch(() => {
        this.$router.replace('/')
      })
    },
    appClose () {
      location.href = 'captvpooq://webclose'
    },
    webClose () {
      const referer = get(this.$route, ['query', 'referer'], null)
      if (referer !== null) {
        if (referer.indexOf('mypooq') > -1) { // myppoq 에서 에디터픽 좋아요 했을때
          this.$router.push('/')
        } else {
          this.$router.replace(referer)
        }
      } else {
        const came = get(this.$route, ['query', 'came'], null)
        if (came !== null && came !== '') {
          this.$router.push({ name: came })
        } else {
          this.$router.back()
        }
      }
    },
    closeList () {
      isApp() ? this.appClose() : this.webClose()
    }
  },
  computed: {
    ...mapGetters(['getListViewParams', 'isVisibleListView']),
    hasOneFilter () {
      return get(this.filterObject, 'filterlist', []).length === 1
    },
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    },
    isMobileDevice () {
      return isMobileDevice()
    }
  },
  created () {
    let text, queryApiUrl
    text = get(this.$route, ['params', 'text'], '')
    queryApiUrl = get(this.$route, ['query', 'api'], '')
    this.selectedCategoryTitle = text
    try {
      if (queryApiUrl !== '') {
        const eventInstance = new EventModelClass({ url: decodeURIComponent(queryApiUrl) })
        const { url, query } = parseUrl(eventInstance.url)
        query.limit = 21
        eventInstance.url = `${url}?${stringify(query)}`
        this.currentEvent = eventInstance
        this.setData(eventInstance)
      } else {
        let target = '/'
        if (this.$route.params.section !== 'home') {
          target = `/${this.$route.params.section}`
        }
        this.$router.replace(target)
      }
    } catch (e) {
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
  .overlay-portal {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .blur>div {
    -webkit-filter: blur(6px);
    filter: blur(6px);
    opacity: 0.7;
  }
  .filter-area {
    width: 100%;
    font-size: 14px;
    line-height: 40px;
    color: #fff;
    background-color: #1b1b1b;
  }
  .filter-item-area {
    padding: 0 10px;
    font-size: 0;
    text-align: right;
  }
  .filter-item-area div {
    display: inline-block;
    margin-left: 14px;
    vertical-align: middle;
  }
  .view-more-editor-pick-header {
    width: 100%;
    box-sizing: border-box;
  }
  .empty-cell-list {
    position: relative;
    height: 250px;
    width: 250px;
    margin: 0 auto;
    top: 70px;
  }
  .empty-cell-list .attention-mark-area {
    height: 50px;
    width: 50px;
    position: relative;
    margin: 0 auto;
  }
  .empty-cell-list .text-area {
    text-align: center;
    margin-top: 16px;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 20px;
  }
  .view-more-layout {
    position: relative;
    /*overflow-x: visible;*/
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index: 5000;
    -webkit-overflow-scrolling: touch;
  }
  .view-more-layout::-webkit-scrollbar{
    display: none;
    background-color: transparent
  }
  .view-more-component-container,
  .view-more-editor-component-container{
    width: 100%;
    position: relative;
    background-color: #1b1b1b;
  }
  .view-more-contents {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .view-more-component-container.fixed {
    position:fixed;
    margin: 0 !important;
    height: 100% !important;
    width: 100% !important;
    /*overflow: hidden !important;*/
  }
</style>
